import React from 'react';
import classes from './AuthorInfo.module.scss';
import {FormattedMessage} from "react-intl";

const AuthorInfo = (props) => {

    let time = '';
    let author = null;
    let dateTime_date = '';
    let dateTime_hour = '';
    if (props.created_on) {
        // date = props.created_on.split(' ')[0];
        // const dDay = date.split('-')[2]; const dMonth = date.split('-')[1]; const dYear = date.split('-')[0]
        time = props.created_on.split(' ')[1];
        dateTime_date = time.split(':')[0];
        dateTime_hour = time.split(':')[1];
        author = props.created_by;
    }

    return (
        <div className={classes.Author_wrapper}>
            <div><FormattedMessage id={"global.by"} defaultMessage={"By "}/>&nbsp;{author}</div>
            <span>|</span>
            <div>{dateTime_date + ':' + dateTime_hour}</div>
        </div>
    );
}

export default AuthorInfo;